import axios from "axios";
import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useMemo,
} from "react";
import { Link, useHistory } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import { Table, TR, TH, TD } from "@ag-media/react-pdf-table";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { translate } from "../../translations";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  ReactPDF,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

export default function Invoice() {
  const [orders, setOrders] = useState([]);
  const { userData } = useContext(UserDataContext);
  const history = useHistory();
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  const [kostenstellen, setKostenstellen] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderDataTotal, setOrderDataTotal] = useState(0);
  var date = new Date();
  const [timePeriod, setTimePeriod] = useState({
    startDate: new Date(date.getFullYear(), date.getMonth(), 1, 3)
      .toISOString()
      .substr(0, 10),
    endDate: new Date(date.getFullYear(), date.getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
    ks: "",
    ksNames: [],
    generate: false,
  });

  async function getData() {
    const userRes = await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/orders/list`,
      { project, startDate: timePeriod.startDate, endDate: timePeriod.endDate },
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    let doneOrders = [];
    let nonUniqueKS = [];

    if (
      userData &&
      userData.permissions &&
      !userData.permissions[project].isProjectAdmin
    ) {
      setOrders(
        userRes.data.filter(
          (order) =>
            userData.permissions[project].kostenstellen.includes(
              order.service.kostenstelle._id
            ) && order.status === "abgenommen"
        )
      );
      doneOrders = userRes.data.filter(
        (order) =>
          userData.permissions[project].kostenstellen.includes(
            order.service.kostenstelle._id
          ) && order.status === "erledigt"
      );
    } else {
      setOrders(userRes.data.filter((order) => order.status === "abgenommen"));
      doneOrders = userRes.data.filter(
        (order) => order.status === "abgenommen"
      );
    }

    doneOrders.map((order) => {
      nonUniqueKS.push(order.service.kostenstelle._id);
    });

    let ksRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/dropdownOptions/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setKostenstellen(ksRes.data.filter((ks) => nonUniqueKS.includes(ks._id)));
  }

  const styles = StyleSheet.create({
    page: {
      fontFamily: "Helvetica",
      fontSize: 11,
      paddingTop: 30,
      paddingLeft: 60,
      paddingRight: 60,
      lineHeight: 1.5,
      flexDirection: "column",
    },
    column_40: {
      width: "40%",
      borderRightWidth: 1,
    },
    column_10: {
      width: "10%",
      borderRightWidth: 1,
    },
    column_10_noborder: {
      width: "10%",
    },
    column_15: {
      width: "15%",
      borderRightWidth: 1,
    },
    column_25: {
      width: "25%",
      borderRightWidth: 1,
    },
    row: {
      flexDirection: "row",
      borderBottomColor: "#bff0fd",
      borderBottomWidth: 1,
      alignItems: "center",
      height: 24,
      textAlign: "center",
      fontStyle: "bold",
      flexGrow: 1,
    },
    footer: {
      width: "33%",
      borderTop: "black",
      borderTopWidth: 1,
      marginRight: 15,
      marginLeft: 15,
      paddingTop: 5,
    },
    footerNoBorder: {
      width: "33%",
      marginRight: 15,
      marginLeft: 15,
      paddingTop: 5,
    },
    logo: {
      height: 30,
      marginLeft: "auto",
      marginRight: "auto",
    },
  });

  useEffect(() => {
    getData();
  }, [timePeriod, userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Abrechnung erstellen
          </h3>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          <div class="flex ml-3">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Von:
            </span>
            <input
              type="date"
              required="true"
              disabled={timePeriod.generate}
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  startDate: e.target.value,
                })
              }
              value={timePeriod.startDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
          <div class="ml-3 mr-3 flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Bis:
            </span>
            <input
              type="date"
              disabled={timePeriod.generate}
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  endDate: e.target.value,
                })
              }
              value={timePeriod.endDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
          <div class="flex mr-3">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Kostenstelle(n):
            </span>
            <select
              required="true"
              multiple
              disabled={timePeriod.generate}
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  ks: Array.from(
                    e.target.selectedOptions,
                    (option) => option.value
                  ),
                })
              }
              value={timePeriod.ks}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            >
              {kostenstellen.map((ks) => (
                <option value={ks._id}>{ks.name}</option>
              ))}
            </select>
          </div>

          {!timePeriod.generate && (
            <div class="flex">
              <button
                onClick={() => {
                  let nonUniqueServices = [];
                  let orderData = [];

                  orders.map((order) => {
                    nonUniqueServices.push(order.service._id);
                  });

                  let set = new Set(nonUniqueServices);
                  let uniqueServices = [...set];

                  uniqueServices.map((service) => {
                    let assignedOrders = orders.filter(
                      (order) => order.service._id === service
                    );

                    let aggregatedOrderData = {
                      durchfuehrungen: 0,
                      summe: 0,
                      serviceId: service,
                    };

                    assignedOrders.map((order) => {
                      let preis =
                        order.service.anzahl *
                        order.service.menge *
                        order.service[order.preis];
                      aggregatedOrderData.durchfuehrungen++;
                      aggregatedOrderData.summe += preis;
                      aggregatedOrderData.name = order.service.pos_name;
                      aggregatedOrderData.posNr = order.service.pos_nr;
                      aggregatedOrderData.kst = order.service.kostenstelle._id;
                    });

                    orderData.push(aggregatedOrderData);
                  });

                  let orderDataTotalCalc = 0;
                  orderData.map((orderData) => {
                    orderDataTotalCalc += orderData.summe;
                  });
                  setOrderData(orderData);
                  setOrderDataTotal(orderDataTotalCalc);

                  let ksNames = [];

                  timePeriod.ks.map((kst) =>
                    kostenstellen
                      .filter((kostenstelle) => kostenstelle._id === kst)
                      .map((kostenstelle) => ksNames.push(kostenstelle.name))
                  );

                  setTimePeriod({
                    ...timePeriod,
                    generate: true,
                    ksNames: ksNames,
                  });
                }}
                className=" whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
              </button>
            </div>
          )}

          {timePeriod.generate && (
            <div class="flex">
              <button
                onClick={() => {
                  history.go(0);
                }}
                className=" whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6 "
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5 border-b border-gray-200 shadow  w-full sm:rounded-lg">
        {timePeriod.generate && (
          <PDFViewer
            className="my-5 mx-5"
            style={{ width: "100%", height: "100vh" }}
          >
            <Document>
              <Page size="A4" style={styles.page}>
                <Image style={styles.logo} src="/logo.png" />
                <View style={[{ flexDirection: "column", marginTop: 24 }]}>
                  <Text
                    style={[
                      {
                        fontSize: 16,
                        textAlign: "center",
                        width: "100%",
                      },
                    ]}
                  >
                    {translate("invoice_headline")}
                  </Text>
                  <View style={{ flexDirection: "row", marginTop: 12 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Zeitraum:{" "}
                      {moment(new Date(timePeriod.startDate)).format(
                        "DD.MM.YYYY"
                      )}{" "}
                      bis{" "}
                      {moment(new Date(timePeriod.endDate)).format(
                        "DD.MM.YYYY"
                      )}
                      . Kostenstelle(n): {timePeriod.ksNames.join(", ")}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: 24,
                      borderWidth: 1,
                      borderColor: "#bff0fd",
                      width: "100%",
                    }}
                  >
                    <Table
                      tdStyle={{ padding: "2px" }}
                      weightings={[0.2, 0.5, 0.15, 0.15]}
                    >
                      <TH style={{ backgroundColor: "#bff0fd" }}>
                        <TD>Position</TD>
                        <TD>Leistung</TD>
                        <TD>Anzahl Durchführungen</TD>
                        <TD>Summe</TD>
                      </TH>
                      {orderData
                        .filter((order) => timePeriod.ks.includes(order.kst))
                        .map((orderData) => (
                          <TR>
                            <TD>{orderData.posNr}</TD>
                            <TD>{orderData.name}</TD>
                            <TD>{orderData.durchfuehrungen}</TD>
                            <TD>{orderData.summe.toFixed(2)} €</TD>
                          </TR>
                        ))}
                      <TR>
                        <TD
                          style={{
                            justifyContent: "center",
                            backgroundColor: "#D3D3D3",
                            paddingRight: 15,
                          }}
                          weighting={1}
                        >
                          Gesamtsumme: {orderDataTotal.toFixed(2)} €
                        </TD>
                      </TR>
                    </Table>
                  </View>
                  <View
                    style={{
                      marginTop: 75,
                      flexDirection: "row",
                      height: 24,
                      textAlign: "center",
                    }}
                  >
                    <Text style={styles.footer}>Datum</Text>
                    <Text style={styles.footer}>
                      {translate("unterschrift_indutec")}
                    </Text>
                    <Text style={styles.footer}>
                      {translate("unterschrift_kunde")}
                    </Text>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
        )}
      </div>
    </>
  );
}
